export const text = {
  pageTitle: "Privacy Policy",
  updateMessage: "Privacy Policy Updated Successfully",
  privacyPolicyDaakia: "Privacy Policy For Daakia",
};
